export default{
    init(){
        if (location.pathname.includes('/admin/system-emails')) {
            this.getEmail();
            this.openInNewTab();
        }
    },

    getEmail(){
        $('#email_type_select').on('change', (e)=>{
            const selectedValue = $(e.currentTarget).val();
            const iframe = $('#preview-frame');
            iframe.attr('src', selectedValue);
        })
    },

    openInNewTab(){
        $('.open_new_tab').click(function(e) {
            const selectedValue = $('#email_type_select').val();
            if (selectedValue !== '') {
                window.open(selectedValue, '_blank')
            }
        });
    }
}
